// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDto } from './IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDto';
import {
    IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDtoFromJSON,
    IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDtoFromJSONTyped,
    IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDtoToJSON,
    IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDtoToJSONTyped,
} from './IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDto';
import type { IParticipantAccountActivitySummaryRecordDto } from './IParticipantAccountActivitySummaryRecordDto';
import {
    IParticipantAccountActivitySummaryRecordDtoFromJSON,
    IParticipantAccountActivitySummaryRecordDtoFromJSONTyped,
    IParticipantAccountActivitySummaryRecordDtoToJSON,
    IParticipantAccountActivitySummaryRecordDtoToJSONTyped,
} from './IParticipantAccountActivitySummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryDtoParticipantAccountActivitySummaryRecordDto
 */
export interface IReportSummaryDtoParticipantAccountActivitySummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryDtoParticipantAccountActivitySummaryRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {Array<IParticipantAccountActivitySummaryRecordDto>}
     * @memberof IReportSummaryDtoParticipantAccountActivitySummaryRecordDto
     */
    employer_records?: Array<IParticipantAccountActivitySummaryRecordDto>;
    /**
     * 
     * @type {Array<IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDto>}
     * @memberof IReportSummaryDtoParticipantAccountActivitySummaryRecordDto
     */
    subsidiary_groups?: Array<IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryDtoParticipantAccountActivitySummaryRecordDto interface.
 */
export function instanceOfIReportSummaryDtoParticipantAccountActivitySummaryRecordDto(value: object): value is IReportSummaryDtoParticipantAccountActivitySummaryRecordDto {
    return true;
}

export function IReportSummaryDtoParticipantAccountActivitySummaryRecordDtoFromJSON(json: any): IReportSummaryDtoParticipantAccountActivitySummaryRecordDto {
    return IReportSummaryDtoParticipantAccountActivitySummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryDtoParticipantAccountActivitySummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryDtoParticipantAccountActivitySummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'employer_records': json['employer_records'] == null ? undefined : ((json['employer_records'] as Array<any>).map(IParticipantAccountActivitySummaryRecordDtoFromJSON)),
        'subsidiary_groups': json['subsidiary_groups'] == null ? undefined : ((json['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryDtoParticipantAccountActivitySummaryRecordDtoToJSON(json: any): IReportSummaryDtoParticipantAccountActivitySummaryRecordDto {
    return IReportSummaryDtoParticipantAccountActivitySummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryDtoParticipantAccountActivitySummaryRecordDtoToJSONTyped(value?: IReportSummaryDtoParticipantAccountActivitySummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employer_name': value['employer_name'],
        'employer_records': value['employer_records'] == null ? undefined : ((value['employer_records'] as Array<any>).map(IParticipantAccountActivitySummaryRecordDtoToJSON)),
        'subsidiary_groups': value['subsidiary_groups'] == null ? undefined : ((value['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDtoToJSON)),
    };
}

